import React from "react";
import "./Loader.css";
import { FadeLoader } from "react-spinners";
import Quote from "./Quote";
export default class Loader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: "en",
    };
    this.hindiTranslate = {
      loan_loading_msg:
        "वाह! आप अपने लोन से मात्र 5 मिनट दूर हैं ! आपकी अवित्तपोषित इंवेनटोरी खोजी जा रही है ।",
    };
  }
  componentDidMount() {
    let lang = localStorage.getItem("lang");
    this.setState({
      lang: lang,
    });
  }
  componentWillUnmount() {
    document.body.style.overflow = "unset";
  }
  render() {
    document.body.style.overflow = "unset";
    if (this.props.isLoading) {
      document.body.style.overflow = "hidden";
    }
    return (
      <>
        {!this.props.fade && this.props.isLoading ? (
          <div className="loader-box">
            <div className="formwrapper">
              <div
                className="m-0 d-block text-center"
                style={{ marginTop: 0, marginBottom: 0 }}
              >
                <div id="circularG">
                  <div id="circularG_1" className="circularG"></div>
                  <div id="circularG_2" className="circularG"></div>
                  <div id="circularG_3" className="circularG"></div>
                  <div id="circularG_4" className="circularG"></div>
                  <div id="circularG_5" className="circularG"></div>
                  <div id="circularG_6" className="circularG"></div>
                  <div id="circularG_7" className="circularG"></div>
                  <div id="circularG_8" className="circularG"></div>
                </div>
                {window?.location?.href.includes(
                  "finance/loan-against-commodity"
                ) ? (
                  <>
                    <p id="">
                      <b>
                        {this.state.lang === "hindi"
                          ? this.hindiTranslate["loan_loading_msg"]
                          : "Wohoo, You are just 5 mins away from your Loan!! Just fetching your unfunded inventory......."}
                      </b>
                    </p>
                  </>
                ) : (
                  <Quote></Quote>
                )}
                {/* <img src={logo} alt="logo" className="img-fluid-image" /> */}
              </div>
            </div>

            {this.props.comingText ? (
              <div className="loader-text" style={{ padding: "10px 96px" }}>
                {this.props.comingText}
              </div>
            ) : (
              <>
                {this.props.isText && (
                  <div className="loader-text">
                    We are calculating your final amount
                  </div>
                )}
              </>
            )}
          </div>
        ) : (
          this.props.isLoading && (
            <div className="sweet-loading loaderBackgaroun">
              <FadeLoader
                css={{
                  display: "block",
                  margin: "0 auto",
                  "border-color": "#5c6b25",
                }}
                size={30}
                color={"#759D40"}
                loading={this.props.isLoading}
              />
              <div
                className="loader-text"
                style={{ padding: "10px 96px", color: "#759D40" }}
              >
                {this.props.comingText}
              </div>
            </div>
          )
        )}
      </>
    );
  }
}
